const LeaderboardIcon = ({ className }: { className?: string }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.375 2.625V6.125V2.625ZM2.625 4.375H6.125H2.625ZM5.25 14.875V18.375V14.875ZM3.5 16.625H7H3.5ZM11.375 2.625L13.3753 8.62488L18.375 10.5L13.3753 12.3751L11.375 18.375L9.37475 12.3751L4.375 10.5L9.37475 8.62488L11.375 2.625Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LeaderboardIcon;
